var latest_offer = function () {
  return {
    init: function() {
      var product_bundles = $('.product-bundle');
      if (product_bundles.length > 0) {
        product_bundles.each(function() {
          var _t = $(this);

          $('.latest-offer-product', _t).each(function() {
            var _tt = $(this);
            var img = $('.latest-offer-product-image-wrapper img', _tt);
            var name = $('.latest-offer-product-title-wrapper h3', _tt);
            var select = $('.latest-offer-product-selector-wrapper select', _tt);

            var handle = $(this).data('product');
            var variants = $(this).data('variants');
              variants = typeof variants !== 'undefined' && variants != '' ? variants.toString().split(',') : [];
            $.getJSON('/products/'+handle+'.js', function(product) {
              var img_src = '',
                  img_alt = '',
                  variant_img_src = '',
                  product_name = '',
                  select_html = '',
                  select_val = '',
                  flag = true;

              img_alt = product.title;
              product_name = product.title;

              if (product.variants.length == 1 || variants.length == 1) {
                // has data-variants and only has one
                $.each(product.variants, function(i, item) {
                  if (product.variants.length == 1 || variants.indexOf(item.id.toString()) >= 0) {
                    variant_img_src = item.featured_image != null ? item.featured_image.src : product.featured_image;
                    img_src = variant_img_src;
                    if (item.available) {
                      if (select_val == '') {
                        select_val = item.id;
                      }
                    } else {
                      // variant.available = false
                      flag = false;
                    }
                    select_html += '<input type="hidden" name="variant_id[]" value="'+item.id+'" '+(! item.available ? "disabled" : "")+' data-available="'+item.available+'" data-img="'+variant_img_src+'">';
                  }
                });
              } else {
                // multiple variants
                var variant_flag = [];
                select_html += '<select name="variant_id[]">';
                $.each(product.variants, function(i, item) {
                  if (variants.length == 0 || variants.indexOf(item.id.toString()) >= 0) {
                    variant_img_src = item.featured_image != null ? item.featured_image.src : product.featured_image;
                    if (item.available) {
                      if (img_src == '') {
                        img_src = variant_img_src;
                      }
                      if (select_val == '') {
                        select_val = item.id;
                      }
                      variant_flag.push('true');
                    } else {
                      // variant.available = false
                      variant_flag.push('false');
                    }
                    select_html += '<option value="'+item.id+'" '+(! item.available ? "disabled" : "")+' data-available="'+item.available+'" data-img="'+variant_img_src+'">'+item.title+'</option>';
                  }
                });
                select_html += '</select>';
                if (img_src == '') img_src = product.featured_image;
                if (variant_flag.indexOf('true') < 0) flag = false;
              }

              // html
              _tt.html(`<div class="latest-offer-product-image-wrapper">
                  <a href="${product.url}"><img src="${img_src}" alt="${img_alt}"></a>
                </div>
                <div class="latest-offer-product-title-wrapper">
                  <h3>${product_name}</h3>
                </div>
                <div class="latest-offer-product-selector-wrapper">
                  ${select_html}
                </div>`);

              $('.latest-offer-product-selector-wrapper select', _tt).val(select_val);
              
              if (! flag) {
                setBundleCta(_tt);
              }
            });
          });
        });
        
        function setBundleCta(_tt) {
          var bundle = _tt.parents('.product-bundle');
          var btn = bundle.find('.btn');
          var inputs = bundle.find('[name="variant_id[]"]');
          if (inputs.length > 0) {
            // check all inputs / select options availability [disabled]
            var total_all = total_disabled = total_inputs = total_selects = 0;
            var total_selects_indv = [];
            inputs.each(function() {
              if (this.nodeName == 'SELECT') {
                total_selects++;
                total_all += $('option', this).length;
                total_disabled += $('option[disabled]', this).length;
                console.log((! $('option:first-child', this).is('[disabled]')).toString())
                total_selects_indv.push((! $('option:first-child', this).is('[disabled]')).toString());
              } else if (this.nodeName == 'INPUT') {
                total_inputs++;
                total_all++;
                total_disabled += $(this).data('available') == false ? 1 : 0;
              }
            });

            if (total_inputs > 0 && total_disabled > 0) {
              // if bundle input
              btn.addClass('disabled').html(window.kef.cart.texts.sold_out);
            } else if (total_selects > 0 && total_selects_indv.indexOf('false') >= 0) {
              // if bundle select box
              btn.addClass('disabled').html(window.kef.cart.texts.sold_out);
            }
          } else {
            // single variant only
            btn.addClass('disabled').html(window.kef.cart.texts.sold_out);
          }
        }

        product_bundles.on('change', 'select', function() {
          var img_src = $('option:selected', this).data('img');
          $(this).parents('.latest-offer-product').find('img').attr('src', img_src);
        });

        product_bundles.on('click', 'button.btn:not(.disabled)', function() {
          var data = {
            items: []
          };
          var _div = $(this).parents('.product-bundle');
          $('[name="variant_id[]"]', _div).each(function() {
            var id = $(this).val();
            var data_item = {
              quantity: 1,
              id: id,
              properties: {}
            }
            var option = $('option[value="'+id+'"]', this);
            var note = option.attr('data-note') || '';
            if (note != '') {
              data_item.properties.note = $(`<div>${note}</div>`).text();
            }
            data.items.push(data_item)
          });

          cart_fn.add(data).done(function(cart) {
            var quantity = data.items.map(function(item, key) {
              return item.quantity;
            });
            $('body').trigger({
              type: 'add_to_cart',
              quantity: quantity,
              cart: cart,
            });
          }).fail(function() {
          }).always(function() {
          });
        });
      }
    }
  }
}();
latest_offer.init();